import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { httpInterceptorProviders } from './interceptors';
import { TokenGuard } from './guards/token.guard';
import { TokenComponent } from './components/token/token.component';
import { LayoutModule } from './layout/layout.module';
import { MaterialModule } from './material.module';
import { ProiecteModule } from './layout/nomenclatoare/proiecte/proiecte.module';
import { SetariProiecteModule } from './layout/nomenclatoare/setari-proiecte/setari-proiecte.module';
import { ProiectePushNotificationsModule } from './layout/nomenclatoare/proiecte-push-notifications/proiecte-push-notifications.module';

import { ToastrModule } from 'ngx-toastr';

@NgModule({
    declarations: [AppComponent, TokenComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        LayoutModule,
        MaterialModule,
        HttpClientModule,
        ProiecteModule,
        ProiectePushNotificationsModule,
        SetariProiecteModule,
        ToastrModule.forRoot(),
    ],
    providers: [httpInterceptorProviders, TokenGuard],
    bootstrap: [AppComponent]
})
export class AppModule { }
